import React from 'react'
import { useHistory } from 'react-router-dom'
import images from 'resources/assets/images'

const Logo = () => {
  const history = useHistory()

  const handleClick = () => {
    history.push('/accueil')
  }

  return <img alt="ORFI" className="logo-small" src={images.homeLogo} onClick={handleClick} />
}

export default Logo
